export function is_kanoodle_solvable(kanoodle_board) {
  let solvable = true;
  kanoodle_board.forEach((row_value, row_index) => {
    if (solvable === false) {
      return;
    }
    row_value.forEach((column_value, column_index) => {
      //if the field is filled in we ignore it
      if (column_value === 1 || solvable === false) {
        return;
      }

      //if the field is empty check if it's surrounded on all sides by 1, 2, or 3 fields
      const top_exists = check_if_exists_on_top_side(
        kanoodle_board,
        row_index,
        column_index,
        1
      );
      const bottom_exists = check_if_exists_on_bottom_side(
        kanoodle_board,
        row_index,
        column_index,
        1
      );
      const left_exists = check_if_exists_on_left_side(
        kanoodle_board,
        row_index,
        column_index,
        1
      );
      const right_exists = check_if_exists_on_right_side(
        kanoodle_board,
        row_index,
        column_index,
        1
      );

      const bottom_two_exists = check_if_exists_on_bottom_side(
        kanoodle_board,
        row_index,
        column_index,
        2
      );
      const right_two_exists = check_if_exists_on_right_side(
        kanoodle_board,
        row_index,
        column_index,
        2
      );
    //   const top_two_exists = check_if_exists_on_top_side(
    //     kanoodle_board,
    //     row_index,
    //     column_index,
    //     2
    //   );
    //   const left_two_exists = check_if_exists_on_left_side(
    //     kanoodle_board,
    //     row_index,
    //     column_index,
    //     2
    //   );

      const bottom_three_exists = check_if_exists_on_bottom_side(
        kanoodle_board,
        row_index,
        column_index,
        3
      );
      const right_three_exists = check_if_exists_on_right_side(
        kanoodle_board,
        row_index,
        column_index,
        3
      );
    //   const top_three_exists = check_if_exists_on_top_side(
    //     kanoodle_board,
    //     row_index,
    //     column_index,
    //     3
    //   );
    //   const left_three_exists = check_if_exists_on_left_side(
    //     kanoodle_board,
    //     row_index,
    //     column_index,
    //     3
    //   );

    //   const top_value_left_value =
    //     row_index === 0 || column_index === 0
    //       ? 1
    //       : kanoodle_board[row_index - 1][column_index - 1];
      const top_value_right_value =
        row_index < 1 || column_index > 9
          ? 1
          : kanoodle_board[row_index - 1][column_index + 1];
      const bottom_value_left_value =
        row_index > 3 || column_index < 1
          ? 1
          : kanoodle_board[row_index + 1][column_index - 1];
      const bottom_value_right_value =
        row_index > 3 || column_index > 9
          ? 1
          : kanoodle_board[row_index + 1][column_index + 1];

      const top_value_left_value_two_horizontal =
        row_index < 1 || column_index < 2
          ? 1
          : kanoodle_board[row_index - 1][column_index - 2];
      const top_value_right_value_two_horizontal =
        row_index < 1 || column_index > 8
          ? 1
          : kanoodle_board[row_index - 1][column_index + 2];
      const bottom_value_left_value_two_horizontal =
        row_index > 3 || column_index < 2
          ? 1
          : kanoodle_board[row_index + 1][column_index - 2];
      const bottom_value_right_value_two_horizontal =
        row_index > 3 || column_index > 8
          ? 1
          : kanoodle_board[row_index + 1][column_index + 2];
    
      const bottom_value_left_value_two_vertical =
        row_index > 2 || column_index < 1
          ? 1
          : kanoodle_board[row_index + 2][column_index - 1];
      const bottom_value_right_value_two_vertical =
        row_index > 2 || column_index > 9
          ? 1
          : kanoodle_board[row_index + 2][column_index + 1];

      //if surrounded on all sides it is not solvable
      const is_surrounded =
        top_exists && bottom_exists && left_exists && right_exists;
      if (is_surrounded) {
        solvable = false;
        return;
      }

      //if has two field gap it is not solvable
      const horizontal_placement_two_gap =
        top_exists &&
        left_exists &&
        bottom_exists &&
        !right_exists &&
        bottom_value_right_value === 1 &&
        top_value_right_value === 1 &&
        right_two_exists;
      const vertical_placement_two_gap =
        top_exists &&
        left_exists &&
        !bottom_exists &&
        right_exists &&
        bottom_value_right_value === 1 &&
        bottom_value_left_value === 1 &&
        bottom_two_exists;
      const has_two_field_gap =
        horizontal_placement_two_gap || vertical_placement_two_gap;

      if (has_two_field_gap) {
        solvable = false;
        return;
      }

      //if has three field gap it is not solvable
      const horizontal_placement_three_gap =
        top_exists &&
        left_exists &&
        bottom_exists &&
        !right_exists &&
        !right_two_exists &&
        bottom_value_right_value === 1 &&
        bottom_value_right_value_two_horizontal === 1 &&
        top_value_right_value === 1 &&
        (top_value_left_value_two_horizontal === 1 || top_value_right_value_two_horizontal) &&
        right_three_exists;
      const vertical_placement_three_gap =
        top_exists &&
        left_exists &&
        right_exists &&
        !bottom_exists &&
        !bottom_two_exists &&
        bottom_value_right_value === 1 &&
        bottom_value_left_value === 1 &&
        bottom_value_right_value_two_vertical === 1 &&
        bottom_value_left_value_two_vertical === 1 &&
        bottom_three_exists;
      const has_three_field_gap =
        horizontal_placement_three_gap || vertical_placement_three_gap;

        // if(row_index === 0 && column_index === 0){
        //     console.log(
        //         top_exists,
        // left_exists,
        // bottom_exists,
        // !right_exists,
        // !right_two_exists,
        // bottom_value_right_value === 1,
        // bottom_value_right_value_two === 1,
        // top_value_right_value === 1,
        // (top_value_left_value_two === 1 || top_value_right_value_two),
        // right_three_exists)
        // }
        

      if (has_three_field_gap) {
        solvable = false;
        return;
      }
    });
  });
  return solvable;
}

function check_if_exists_on_left_side(
  kanoodle_board,
  row_index,
  col_index,
  amount_to_check
) {
  if (col_index - amount_to_check < 0) {
    return true;
  } else {
    return kanoodle_board[row_index][col_index - amount_to_check] === 1;
  }
}

function check_if_exists_on_right_side(
  kanoodle_board,
  row_index,
  col_index,
  amount_to_check
) {
  if (col_index + amount_to_check > 10) {
    return true;
  } else {
    return kanoodle_board[row_index][col_index + amount_to_check] === 1;
  }
}

function check_if_exists_on_top_side(
  kanoodle_board,
  row_index,
  col_index,
  amount_to_check
) {
  if (row_index - amount_to_check < 0) {
    return true;
  } else {
    return kanoodle_board[row_index - amount_to_check][col_index] === 1;
  }
}

function check_if_exists_on_bottom_side(
  kanoodle_board,
  row_index,
  col_index,
  amount_to_check
) {
  if (row_index + amount_to_check > 4) {
    return true;
  } else {
    return kanoodle_board[row_index + amount_to_check][col_index] === 1;
  }
}

// takes an array of the formation of kanoodle pieces
// returns a json object that tells us if the current formation is
// solvable and all the solutions possible.
// export function solve_kanoodle(chosen_piece, kanoodle_board, pieces) {
//   //TODO: implement
//   let new_kanoodle_board = kanoodle_board.map((x) => x);
//   let pieces_to_place = pieces.filter((x) => x.Piece !== chosen_piece.Piece);
// }

// take a piece shape 2-d array
// rotate it 90 degrees in the direction asked
// return rotated 2-d array
export function rotate_piece(piece) {
  const rotated_piece = piece[0].map((val, index) =>
    piece.map((row) => row[index]).reverse()
  );
  return rotated_piece;
  // if(direction.lower() === "right"){
  //     piece[0].map((val, index) => piece.map(row => row[index]).reverse());
  // }

  // if(direction.lower() === "left"){
  //     piece[0].map((val, index) => piece.map(row => row[row.length-1-index]));
  // }
}
